export default function WelcomeVideo() {
  return (
    <section
      id="bienvenida"
      data-testid="welcome-video-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10 overflow-hidden"
    >
      <div className="absolute inset-0 pattern-hypnotic-radial" />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-12">
        <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-12 flex items-center gap-4 justify-center">
          <span className="h-px w-12 bg-[#B49A6C]/50" />
          Bienvenida
          <span className="h-px w-12 bg-[#B49A6C]/50" />
        </p>

        <div className="relative">
          <div
            className="absolute inset-0 -z-10 blur-3xl opacity-50"
            style={{
              background:
                "radial-gradient(circle at center, rgba(217,205,168,0.20) 0%, transparent 65%)",
            }}
          />
          <div className="relative overflow-hidden ring-1 ring-[#B49A6C]/25 shadow-[0_30px_60px_rgba(0,0,0,0.7)] bg-black">
            <video
              data-testid="welcome-video"
              src="/bienvenida.mp4"
              controls
              playsInline
              preload="metadata"
              className="w-full h-auto block"
            />
          </div>
        </div>

        <p
          data-testid="welcome-contact"
          className="mt-12 text-center text-base sm:text-lg font-light tracking-wide leading-relaxed"
          style={{
            background:
              "linear-gradient(180deg, #E8E5DC 0%, #C9C2B0 55%, #7A7468 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
            color: "transparent",
          }}
        >
          Si tienes dudas puedes contactarme vía Instagram{" "}
          <a
            href="https://instagram.com/yussefobeid"
            target="_blank"
            rel="noopener noreferrer"
            className="italic underline decoration-[#B49A6C]/40 underline-offset-4 hover:decoration-[#B49A6C]"
          >
            @yussefobeid
          </a>
        </p>
      </div>
    </section>
  );
}
